var map = {
	"./cnr/translation.toml": [
		"./locale/cnr/translation.toml",
		"locale_cnr_translation_toml"
	],
	"./de/translation.toml": [
		"./locale/de/translation.toml",
		"locale_de_translation_toml"
	],
	"./en/translation.toml": [
		"./locale/en/translation.toml",
		"locale_en_translation_toml"
	],
	"./es-mx/translation.toml": [
		"./locale/es-mx/translation.toml",
		"locale_es-mx_translation_toml"
	],
	"./fr/translation.toml": [
		"./locale/fr/translation.toml",
		"locale_fr_translation_toml"
	],
	"./hi/translation.toml": [
		"./locale/hi/translation.toml",
		"locale_hi_translation_toml"
	],
	"./it/translation.toml": [
		"./locale/it/translation.toml",
		"locale_it_translation_toml"
	],
	"./nl/translation.toml": [
		"./locale/nl/translation.toml",
		"locale_nl_translation_toml"
	],
	"./ph/translation.toml": [
		"./locale/ph/translation.toml",
		"locale_ph_translation_toml"
	],
	"./pl/translation.toml": [
		"./locale/pl/translation.toml",
		"locale_pl_translation_toml"
	],
	"./pt-br/translation.toml": [
		"./locale/pt-br/translation.toml",
		"locale_pt-br_translation_toml"
	],
	"./pt-pt/translation.toml": [
		"./locale/pt-pt/translation.toml",
		"locale_pt-pt_translation_toml"
	],
	"./pt/translation.toml": [
		"./locale/pt/translation.toml",
		"locale_pt_translation_toml"
	],
	"./template/translation.toml": [
		"./locale/template/translation.toml"
	],
	"./uwu/translation.toml": [
		"./locale/uwu/translation.toml",
		"locale_uwu_translation_toml"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = "./locale lazy recursive ^\\.\\/.*\\/translation\\.toml$";
module.exports = webpackAsyncContext;